import { Navigate, Outlet } from 'react-router-dom';
import { useContext } from 'react';
import AuthContext from '../context/AuthContext';
import PropTypes from 'prop-types';

const ProtectedRoute = ({ allowedRoles }) => {

    const { userrole, loading } = useContext(AuthContext);
  const numericRoles = allowedRoles.map(role =>
    role === "admin" ? role : Number(role)
  );
    if (loading) {
        return <div>Loading...</div>; 
    }
    console.log(userrole,"userrole")
    if (!userrole) {
        return <Navigate to="/login" replace />;
    }

    if (!numericRoles.includes(userrole)) {
        return <Navigate to="/not-found" replace />;
    }

    return <Outlet />;
};

ProtectedRoute.propTypes = {
    allowedRoles: PropTypes.arrayOf(PropTypes.string).isRequired, // Fix PropTypes
};

export default ProtectedRoute;